export const environment = {
  production: false,
  develop: true,
  apiURL: 'https://nightly.cms.btv-intern.de/api/v1',
  serverURL: 'https://nightly.cms.btv-intern.de',
  watermark: 'SyBi Testumgebung nigthly',
  phoenixUri: 'https://testbtv.it4sport.de',
  ssePath: '/bridge',
};
